import axios from 'axios';
import { accessToken } from './helpers';

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_DROPS_URL,
  timeout: 120000,
});

interface IOptions {
  token?: string;
  next?: boolean;
}

export default function https(options?: IOptions) {
  instance.interceptors.request.use(
    (request) => {
      if (options?.next) {
        request.baseURL = '';
      }

      if (options?.token) {
        request.headers['Authorization'] = `Bearer ${options.token}`;
      }

      return request;
    },
    (error) => Promise.reject(error),
  );

  return instance;
}

export const fetcher = async (url: string) => {
  const token = accessToken.get();
  return https({ token }).get(url).then((res) => res.data);
};
